import { render } from "./TabHome.vue?vue&type=template&id=336166cd"
import script from "./TabHome.vue?vue&type=script&lang=js"
export * from "./TabHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__